import axios from 'axios'
import API_URL from '@/router/api'

export const create = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.pages.create, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const update = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.pages.update.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findById = (ctx, id) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.pages.findById.replace(/__id__/, id)

        axios.get(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const deletePage = (ctx, {id}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.pages.delete.replace(/__id__/, id)

        axios.delete(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findMany = (ctx, query = {}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.pages.findMany

        axios.get(url, {
            params: query
        }).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const updatePageOrder = (ctx, { form }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.pages.updatePageOrder

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getListPageCategory = () => {
    return new Promise((resolve, reject) => {
        const url = API_URL.pages.getListPageCategory

        axios.get(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const createPageCategory = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.pages.createPageCategory, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const updatePageCategory = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.pages.updatePageCategory.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const deletePageCategory = (ctx, id) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.pages.deletePageCategory.replace(/__id__/, id)

        axios.delete(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
